import React, { FunctionComponent } from 'react'
import SummaryCard from '../../molecules/SummaryCard'
import { SummarySorted } from '../../../redux/requests/products/product.types'
import { randomID } from '../../../redux/misc/helpers'
import * as S from './styled'

type OwnProps = {
  dashboardData?: SummarySorted[]
  singleDocumentData?: any[]
}

type Props = OwnProps

export const SummaryRow: FunctionComponent<Props> = ({ dashboardData, singleDocumentData }) => {
  return (
    <S.Container>
      {dashboardData
        ? dashboardData.length &&
          dashboardData.map(obj => (
            <SummaryCard
              key={randomID()}
              label={obj['label']}
              value={obj['value']}
              direction={obj['direction']}
              moreIsBad={obj['moreIsBad']}
            />
          ))
        : singleDocumentData?.map(obj => (
            <SummaryCard
              key={randomID()}
              label={obj['label']}
              value={obj['value']}
              icon={obj['icon']}
            />
          ))}
    </S.Container>
  )
}

export default SummaryRow
